import { render } from "./CalculationItemsSection.vue?vue&type=template&id=502b68df&scoped=true"
import script from "./CalculationItemsSection.vue?vue&type=script&lang=js"
export * from "./CalculationItemsSection.vue?vue&type=script&lang=js"

import "./CalculationItemsSection.vue?vue&type=style&index=0&id=502b68df&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-502b68df"]])

export default __exports__